import moment from 'moment';

module.exports = function () {
    var timeFormat = function (time, format) {
        switch (format) {
            case 'strdDateObj':
                return new Date(time*1000);
            break;
            case 'chartHover':
                return moment(time).format('YYYY/MM/DD HH:mm');
            break;
            case 'table':
            case 'tables':
                return moment.unix(time).format('YYYY/MM/DD HH:mm:ss');
            break;
            case 'tableMinMax':
            case 'tablesMinMax':
                return moment.unix(time).format('MMMM D, YYYY h:mm A');
            break;
            case 'first_seen':
                if ((moment(new Date).unix() - (time)) < 86400) {
                    return "New"
                }
                return Math.round((moment(new Date).unix()-(time))/86400)+ " Days ago";
            break;
            case 'timeSlider':
                return moment(time*1000).format('YYYY/MM/DD HH:mm:ss');
            break;
            case 'laneGraphExpanded':
                return moment(time*1000).format('YYYY/MM/DD HH:mm:ss.SS');
            break;
            case 'laneGraphPreview':
                return moment(time*1000).format('YYYY/MM/DD HH:mm:ss.SS');
            break;
            case 'iochits':
                return moment(time*1000).format('YYYY-MM-DD HH:mm:ss');
            break;
            default:
                return moment.unix(time).format('YYYY/MM/DD HH:mm:ss');
            break;
        }
    };
    return timeFormat;
}


/** WEBPACK FOOTER **
 ** ./src/pages/services/timeformat.js
 **/